import FileSaver from "file-saver";
import * as xlsx from "xlsx";
import settings from "../config/settings";
import axios from 'axios'
import { timeDimensionMapper } from './Reusables'
import _ from 'lodash'
import moment from 'moment'
import { decode } from 'html-entities';
import { mergeReportsDataMaster } from "./MergeReport";


const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const fileExtension = ".xlsx";
const  { CUBE_API_URL } = settings

  const getCubeData = (payload) => {
  var instance = axios.create();
  delete instance.defaults.headers.common['accessToken'];
  return instance.post(`${CUBE_API_URL}/cubejs-api/v1/load`,payload,{
    headers: {
          'Authorization': localStorage.getItem('cubeToken')
    }
  })
} 

  const handleChartLabel = (key,columnDisplayName,columnTitle) => {
    let label;
    let columnLabel = { ...columnDisplayName }
    if (columnTitle && columnTitle.length && Object.keys(columnTitle[0]).length) {
        for (let title of Object.keys(columnTitle[0])) {
            if (columnTitle[0][title]) {
                columnLabel[title] = columnTitle[0][title]
            }
        }
    }

    if (key && columnLabel && Object.keys(columnLabel).length && columnLabel[key]) {
        label = columnLabel[key]
        if (Object.keys(columnLabel).length === 1) {
            if (columnLabel[key].trim() === '') {
                label = label.replace(',', '')
            }
        }
        else {
            for (let index = 0; index < Object.keys(columnLabel).length; index++) {
                if (index !== 0) {
                    if (key === Object.keys(columnLabel)[index] && columnLabel[Object.keys(columnLabel)[index - 1]].trim() === '') {
                        label = columnLabel[key].replace(',', '')
                    }
                }
            }
        }
    }
    else if (key && columnLabel && Object.keys(columnLabel).length) {
        for (let col of Object.keys(columnLabel)) {
            if (key.includes(col)) {
                let temp = key;
                if (columnLabel[col].trim() === '') {
                    key = key.replace(`,${col}`, columnLabel[col]);
                    if (temp === key) {
                        key = key.replace(col, columnLabel[col]);
                    }
                }
                else {
                    key = key.replace(col, columnLabel[col]);
                }
                label = key;
            }
        }
    }
    else {
        label = _.startCase(key?.split('.')[1])
    }
    return label;
}

const formatNumberTimeField = (value, format, type) => {
  let strHr, hours, minutes, seconds;

  if (type === 'second') {
    const sec = parseInt(value, 10);
    hours = Math.floor(sec / 3600);
    minutes = Math.floor((sec - (hours * 3600)) / 60);
    seconds = sec - (hours * 3600) - (minutes * 60);
    if (hours < 10) {
      if (hours) {
        strHr = "0" + hours;
      }
      hours = "0" + hours;
    }
    else {
      strHr = hours
    }
    if (minutes < 10) { minutes = "0" + minutes; }
    if (seconds < 10) { seconds = "0" + seconds; }
  }
  else if (type === 'minute') {
    const min = parseFloat(value, 10);
    hours = Math.floor(min / 60);
    minutes = Math.floor((min - ((hours * 3600)) / 60));
    seconds = Math.floor((min * 60) - (hours * 3600) - (minutes * 60));

    if (hours < 10) {
      if (hours) {
        strHr = "0" + hours;
      }
      hours = "0" + hours;
    }
    else {
      strHr = hours
    }

    if (minutes < 10) { minutes = "0" + minutes; }
    if (seconds < 10) { seconds = "0" + seconds; }
  }
  else if (type === 'hour') {
    const hr = parseFloat(value, 10);
    hours = Math.floor(hr);
    minutes = (Math.abs(hr) - hours) * 60
    seconds = (Math.abs(minutes) - Math.floor(minutes)) * 60

    if (hours < 10) {
      if (hours) {
        strHr = "0" + hours;
      }
      hours = "0" + hours;
    }
    else {
      strHr = hours
    }
    if (minutes < 10) { minutes = "0" + minutes; }
    if (seconds < 10) { seconds = "0" + seconds; }
  }

  let formatted;

  switch (format) {
    case 'hh:mm:ss':
      formatted = hours + ':' + minutes + ':' + seconds;
      break;
    case 'HH:MM:SS':
      if (strHr) {
        formatted = `${hours}hour : ${minutes}minute : ${seconds}second`
      }
      else {
        formatted = `${minutes}minute : ${seconds}second`
      }
      break;
    default:
      formatted = value
      break;
  }
  return formatted;
}


const handleTimeDimensionFormat = ({data,timeDimensions,reportDetails}) => {
    let TimeGranularityKey = null
    let GranularityDateFormat = ''
    const {timeDimensionDateFormat,dateFieldFormat,fieldFormat } = reportDetails?.vizState

    if (timeDimensions && timeDimensions.length) {
      let { dimension, granularity } = timeDimensions[0]
      TimeGranularityKey = `${dimension ?? ''}.${granularity ?? ''}`

      let dateFormat = 'DD MMM YY'

      switch (granularity) {
        case 'hour':
          dateFormat = dateFormat + " HH"
          break;
        case 'minute':
          dateFormat = dateFormat + " HH:mm"
          break;
        case 'second':
          dateFormat = dateFormat + " HH:mm:ss"
          break;
        case 'month':
          dateFormat = "MMM YY"
          break;
        case 'year':
          dateFormat = "YYYY"
          break;
        default:
          break
      }
      GranularityDateFormat = dateFormat
    }
    let rowsCount = 1
    for (let pivot of data) {
      // pivot['serialNo'] = rowsCount
      rowsCount++
      if(timeDimensionDateFormat && Object.values(timeDimensionDateFormat)?.length) {
        for(let f of Object?.values(timeDimensionDateFormat)) {
          let {format,key,granularity} = f
          let granKey = key+'.'+granularity
          if(pivot[granKey] && format) {
             pivot[granKey] = moment(pivot[granKey]).format(format)
          }
          else if(pivot[TimeGranularityKey] && GranularityDateFormat) {
             pivot[TimeGranularityKey] = moment(pivot[TimeGranularityKey]).format(GranularityDateFormat)    
          }
        }
      }
      else if(pivot[TimeGranularityKey] && GranularityDateFormat) {
        pivot[TimeGranularityKey] = moment(pivot[TimeGranularityKey]).format(GranularityDateFormat)
      }
      if (dateFieldFormat && Object.keys(dateFieldFormat).length) {
        for (let obj of Object.keys(dateFieldFormat)) {
          let [field, type] = obj.split('_')
          if (type === 'date' && pivot[field]) {
            pivot[field] = moment(pivot[field]).format(dateFieldFormat[obj])
          }
          else if (pivot[field]) {
            const formatted = formatNumberTimeField(pivot[field], dateFieldFormat[obj], type);
            pivot[field] = formatted
          }

        }
      }

      if (fieldFormat && Object.keys(fieldFormat).length) {
        for (let obj of Object.keys(fieldFormat)) {
          if (pivot[obj] && fieldFormat[obj] === 'percent') {
            pivot[obj] = pivot[obj] + '%'
          }
        }
      }
      for (let key of Object.keys(pivot)) {
        if (pivot[key] === undefined || pivot[key] === null || pivot[key] === 'NaN') {
          pivot[key] = 'NA'
        }
        if (pivot[key]) {
          pivot[key] = decode(pivot[key])
        }
      }
    }
    return data
}

  const initXLSXExport = async (reportDetails,mapResponseForQuery,columnTitle,columnDisplayName) => {
   if(reportDetails?.reportDetails) {
      const reportDetailsData = mapResponseForQuery(reportDetails?.reportDetails);
      const reportQuery = timeDimensionMapper(reportDetailsData?.vizState?.query)
      const data = await getCubeData({query:reportQuery})
      if(data?.data?.data?.length) {
        const { timeDimensions } = data?.data?.query
        let modifiedData = []
        if(reportDetails?.reportDetails?.mergeReport?.length > 0){
          modifiedData = await mergeReportsDataMaster(reportQuery,reportDetails?.reportDetails?.mergeReport)
        }else{
          modifiedData = handleTimeDimensionFormat({data:data?.data?.data,timeDimensions,reportDetails: reportDetailsData})
        }
        const {wscols,headers,csvData,Heading} = transformCsvData(modifiedData,columnTitle,columnDisplayName,reportDetails);
        let updatedHeaders = headers.filter( h => typeof(h) === 'object')
         exportXLSX(csvData, reportDetails?.reportDetails?.reportName ? reportDetails?.reportDetails?.reportName+'.csv' : 'test.csv', wscols, updatedHeaders,Heading)
      }
    }
  }

  const retryCubeQuery=(queryFunction, retries = 5, delay = 1000) => {
    return new Promise((resolve, reject) => {
      const attempt = async (n) => {
        try {
          const response = await queryFunction();
          if (response?.data?.error === "Continue wait" && n > 0) {
            setTimeout(() => attempt(n - 1), delay);
          } else {
            resolve(response);
          }
        } catch (error) {
          if (n === 0) {
            reject(error); 
          } else {
            setTimeout(() => attempt(n - 1), delay);
          }
        }
      };
      attempt(retries);
    }
  );
  }

  const initXLSXExportMultiple = async (
    reportDetailsArray,
    mapResponseForQuery,
    handleColumnDisplayName
  ) => {
    try{
      if (reportDetailsArray && reportDetailsArray.length) {
        const wb = { Sheets: {}, SheetNames: [] };
  
        const cubeDataPromises = reportDetailsArray.map((reportDetails) => {
          const reportDetailsData = mapResponseForQuery(reportDetails);
          const reportQuery = timeDimensionMapper(
            reportDetailsData?.vizState?.query
          );
          return retryCubeQuery(()=>getCubeData({ query: reportQuery }));
        });
  
        const cubeDataResults = await Promise.all(cubeDataPromises);
  
        for (let i = 0; i < reportDetailsArray.length; i++) {
          const reportDetails = reportDetailsArray[i];
          const cubeResult = cubeDataResults[i];
          const reportDetailsData = mapResponseForQuery(reportDetails);
          const reportQuery = timeDimensionMapper(
            reportDetailsData?.vizState?.query
          );
  
          let dimensionTitle = {};
          let measureTitle = {};
  
          reportDetails?.dimensions?.map((dim) => {
            let key = dim?.fieldName;
            dimensionTitle[key] = dim?.title;
          });
          reportDetails?.measures?.map((meas) => {
            let key = meas?.fieldName;
            measureTitle[key] = meas?.title;
          });
          const columnTitle = [{ ...dimensionTitle, ...measureTitle }];
          const columnDisplayName = handleColumnDisplayName(reportDetails);
  
          const data = cubeResult;
          if (data?.data?.data?.length) {
            const { timeDimensions } = data?.data?.query;
            let modifiedData = [];
  
            if (reportDetails?.mergeReport?.length > 0) {
              modifiedData = await mergeReportsDataMaster(
                reportQuery,
                reportDetails?.mergeReport
              );
            } else {
              modifiedData = handleTimeDimensionFormat({
                data: data?.data?.data,
                timeDimensions,
                reportDetails: reportDetailsData,
              });
            }
  
            const { wscols, headers, csvData, Heading } = transformCsvData(
              modifiedData,
              columnTitle,
              columnDisplayName
            );
  
            let updatedHeaders = headers.filter((h) => typeof h === "object");
  
            const ws = xlsx.utils.json_to_sheet(Heading, {
              header: updatedHeaders,
              skipHeader: true,
              origin: 0,
            });
            ws["!cols"] = wscols;
            xlsx.utils.sheet_add_json(ws, csvData, {
              header: updatedHeaders,
              skipHeader: true,
              origin: -1,
            });
  
            wb.Sheets[reportDetails?.reportName.substring(0, 30) || `Report ${i + 1}`] = ws;
            wb.SheetNames.push(reportDetails?.reportName.substring(0, 30) || `Report ${i + 1}`);
          }
        }
  
        if (wb.SheetNames.length > 0) {
          const excelBuffer = xlsx.write(wb, { bookType: "xlsx", type: "array" });
          const data = new Blob([excelBuffer], { type: fileType });
          FileSaver.saveAs(data, "multiple_reports_export.xlsx");
        } else {
          throw new Error("No data available for export.");
        }
      }
    }
    catch (error) {
      console.error("Error during XLSX export:", error);
    }
  };
  


  const transformCsvData = (data, columnTitle, columnDisplayName, reportDetails) => {
    const orderedColumns = [];
    const hiddenColumns = new Set();
  
    // Get hidden columns from dimensions
    reportDetails?.reportDetails?.dimensions?.forEach(dim => {
      if (dim.isHidden) {
        hiddenColumns.add(dim.fieldName);
      }
    });

   reportDetails?.reportDetails?.settings?.groupBySettings?.forEach(group => {
     if (group.concatWith && Array.isArray(group.concatWith)) {
       group.concatWith.forEach(field => {
         hiddenColumns.add(field);
       });
     }
   });
  
    // Get ordered columns from dimensions while excluding hidden ones
    reportDetails?.reportDetails?.pivotConfig?.xAxis?.list?.forEach(item => {
      if(!hiddenColumns.has(item.text)) {
      orderedColumns.push(item.text);
      }
    });
  
    // Add measures to ordered columns
    reportDetails?.reportDetails?.measures?.forEach(measure => {
      if(!hiddenColumns.has(measure.fieldName)) {
      orderedColumns.push(measure.fieldName);
      }
    });

    const headers = orderedColumns;
    
    const wscols = headers?.map(h => ({
      wch: Math.max(...data.map((d) => d[h] ? d[h].toString().length : 0))
    }));

    const Heading = {};
    headers.forEach(h => {
      Heading[h] = handleChartLabel(h, columnDisplayName, columnTitle) || _.startCase(h?.split('.')[1]);
    });
  
    // Filter out hidden columns from data
    const filteredData = data.map(row => {
      const newRow = {};
      headers.forEach(key => {
        if (!hiddenColumns.has(key)) {
          newRow[key] = row[key];
        }
      });
      return newRow;
    });
  
    return {
      wscols,
      headers,
      csvData: filteredData,
      Heading: [Heading]
    };
  };

  const exportXLSX = (csvData, fileName, wscols, headers,Heading) => {

    const ws = xlsx.utils.json_to_sheet(Heading, {
      header: headers,
      skipHeader: true,
      origin: 0 
    });
    ws["!cols"] = wscols;
    xlsx.utils.sheet_add_json(ws, csvData, {
      header: headers,
      skipHeader: true,
      origin: -1 
    });

    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = xlsx.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension)
  };

  
export { initXLSXExport, initXLSXExportMultiple };